export function CreditCardListModel() {
    this.id = null;
    this.brand = null;
    this.lastDigits = null;
    this.isSelect = false;
    this.isDefault = false;
    this.name = null;

    this.setValueFormApi = function(data) {
        if (data == null) {
            data = {};
        }
        this.id = data.id;
        this.brand = data.brand;
        this.lastDigits = data.last_digits;
        this.name = data.name;
        this.isDefault = data.isdefault;
    }

    this.setValueFormOmise = function(data) {
        if (data == null) {
            data = {};
        }
        this.id = data.id;
        this.brand = data.card.brand;
        this.lastDigits = data.card.last_digits;
        this.name = data.card.name;
    }
}
